import {TeamAssignmentStateActions as actions} from '../../const/actionType';

const initialState = {
  assignedEmployee: [],
  employeeIdToAssign: [],
  employeeIdToRemove: null,
  employeeIdToRoleChange: [],
  projects: [],
  saveAssignButton: false,
  selectedProject: [],
  showModalDatePicker: false,
  showModalTeam: false,
  teamProject: [],
  historyData:[],
  isLoadingHistory: false,
  isLoadingTeamAssignment: false
};

const teamAssignmentStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_PROJECTS:
      return {...state, projects: action.projects};
    case actions.SET_ASSIGNED_EMPLOYEE:
      return {...state, assignedEmployee: action.assignedEmployee};
    case actions.SET_EMPLOYEE_ID_TO_ROLE_CHANGE:
      return {...state, employeeIdToRoleChange: action.employeeIdToRoleChange};
    case actions.SET_EMPLOYEE_ID_TO_ASSIGN:
      return {...state, employeeIdToAssign: action.employeeIdToAssign};
    case actions.SET_SELECTED_PROJECT:
      return {...state, selectedProject: action.selectedProject};
    case actions.SET_TEAM_PROJECT:
      return {...state, teamProject: action.teamProject};
    case actions.SET_AVAILABLE_EMPLOYEE:
      return {...state, availableEmployee: action.availableEmployee};
    case actions.SET_SHOW_MODAL_TEAM:
      return {...state, showModalTeam: action.showModalTeam};
    case actions.SET_SHOW_MODAL_DATE_PICKER:
      return {...state, showModalDatePicker: action.showModalDatePicker};
    case actions.RESET_STATE_TEAM_ASSIGNMENT:
      return initialState;
    case actions.SET_EMPLOYEE_ID_TO_REMOVE:
      return {...state, employeeIdToRemove: action.employeeIdToRemove};
    case actions.SET_SAVE_ASSIGN_BUTTON:
      return {...state, saveAssignButton: action.saveAssignButton};
    case actions.SET_HISTORY_DATA:
      return {...state, historyData: action.historyData}
    case actions.SET_HISTORY_LOADING:
      return {...state, isLoadingHistory: action.isLoading};
    case actions.SET_TEAM_ASSIGNMENT_LOADING:
      return {...state, isLoadingTeamAssignment: action.isLoading};
    default:
      return state;
  }
};

export default teamAssignmentStateReducer;
